// src/features/reports/components/Reports/components/ReportsStatsStrip.jsx
import React from 'react';
import styles from '../Reports.module.css';
import { formatNumber } from '../../../../../shared/utils/formatters';

function StatCell({ label, value, unit, color, onClick, active }) {
  return (
    <button
      type="button"
      className={`${styles.statCell} ${color ? styles[`sc_${color}`] : ''} ${active ? styles.statActive : ''}`}
      onClick={onClick}
    >
      <span className={styles.statVal}>{formatNumber(value, 0)}</span>
      <span className={styles.statLbl}>{label}</span>
      {unit && <span className={styles.statUnit}>{unit}</span>}
    </button>
  );
}

export default function ReportsStatsStrip({
  summary,
  netProfit,
  totalExpenses,
  genExpValue,
  tableView,
  expenseFilter,
  onSetView,
  onSetExpFilter,
}) {
  if (!summary) return null;

  // ✅ صافي الربح: أحمر إذا سالب، أزرق إذا موجب
  const netProfitColor = netProfit < 0 ? 'red' : 'blue';

  return (
    <div className={styles.statsStrip}>
      <StatCell
        label="إجمالي الإيرادات"
        value={summary.total_revenue}
        unit="د.ع"
        color="teal"
        onClick={() => onSetView('revenue')}
        active={tableView === 'revenue'}
      />
      <StatCell
        label="صافي الربح"
        value={netProfit}
        unit="د.ع"
        color={netProfitColor}
        onClick={() => onSetView('revenue')}
        active={tableView === 'revenue'}
      />
      <StatCell
        label="إجمالي المصاريف"
        value={totalExpenses}
        unit="د.ع"
        color="red"
        onClick={() => { onSetView('expenses'); onSetExpFilter('all'); }}
        active={tableView === 'expenses' && expenseFilter === 'all'}
      />
      <StatCell
        label="مصاريف حجوزات"
        value={summary.total_booking_expenses}
        unit="د.ع"
        color="orange"
        onClick={() => { onSetView('expenses'); onSetExpFilter('booking'); }}
        active={tableView === 'expenses' && expenseFilter === 'booking'}
      />
      <StatCell
        label="مصاريف عامة"
        value={genExpValue}
        unit="د.ع"
        color="purple"
        onClick={() => { onSetView('expenses'); onSetExpFilter('general'); }}
        active={tableView === 'expenses' && expenseFilter === 'general'}
      />
      <StatCell
        label="عدد الحجوزات"
        value={summary.bookings_count}
        unit="حجز"
        color="default"
      />
      <StatCell
        label="إجمالي المستلم"
        value={summary.total_received}
        unit="د.ع"
        color="green"
      />
      <StatCell
        label="إجمالي المتبقي"
        value={summary.total_remaining}
        unit="د.ع"
        color="amber"
      />
    </div>
  );
}